import { createFileIcon } from '../createFileIcon/createFileIcon';
import FileIconTxtSizeM from './FileIconTxt_size_m';
import FileIconTxtSizeS from './FileIconTxt_size_s';

export const FileIconTxt = createFileIcon({
  m: FileIconTxtSizeM,
  s: FileIconTxtSizeS,
  name: 'FileIconTxt',
});
